export default __webpack_public_path__ + "static/media/10.ab1afdd8.jpg";